import { __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';
import { hiddenVisuallyCSS } from '../HiddenVisually/index.js';
import { Label } from '../Label/index.js';
import { Box } from '../Box/index.js';
import { Text } from '../Text/Text.js';

var ToggleInputLabelled = function (props) {
    var children = props.children, id = props.id, label = props.label, size = props.size, sx = props.sx, className = props.className, disabled = props.disabled, input = props.input, hideLabel = props.hideLabel;
    var mergeStyles = useTheme().mergeStyles;
    var layout = {
        display: "grid",
        position: "relative",
        alignItems: "center",
        gridTemplateColumns: "min-content 1fr",
        gridColumnGap: "0.5em",
        gridTemplateAreas: "\n      \"input label\"\n      \"null description\"\n    ",
    };
    var labelCss = hideLabel && hiddenVisuallyCSS;
    return (jsxs(Box, __assign({ sx: mergeStyles([layout, sx]), className: className }, { children: [jsx(Label, __assign({ size: size, disabled: disabled, sx: { alignSelf: "start" } }, { children: input })), jsx(Label, __assign({ sx: __assign({}, labelCss), htmlFor: id, size: size, disabled: disabled }, { children: label })), !!children && (jsx(Box, __assign({ sx: { gridArea: "description" } }, { children: jsx(Text, __assign({ size: "sm", tone: "subtle", crop: true }, { children: children })) })))] })));
};

export { ToggleInputLabelled };
//# sourceMappingURL=ToggleInputLabelled.js.map
